import { useBoundValue } from "lib/@components/binding/use-bound-value.js"
import { Typography } from "@mui/material"
import { StandardAutocomplete } from "lib/@components/binding/bound-components.js"
import { toDataCy } from "lib/to-data-cy.js"
import { LAWS } from "routes/asset-register/plugins/asset-mapping/constants.js"

const LEGISLATION_OPTIONS = Object.values(LAWS)

export function MappingSettingsLegislationContent() {
    const [english, setEnglish] = useBoundValue("english", false)
    const [welsh, setWelsh] = useBoundValue("welsh", false)
    const [scottish, setScottish] = useBoundValue("scottish", false)
    const [northernIreland, setNorthernIreland] = useBoundValue("northernIreland", false)

    const legislation = [
        english && LAWS.english,
        welsh && LAWS.welsh,
        scottish && LAWS.scottish,
        northernIreland && LAWS.northernIreland,
    ].filter(Boolean)

    return (
        <StandardAutocomplete
            options={LEGISLATION_OPTIONS}
            onChange={setLegislation}
            value={legislation}
            data-cy="mapping-rule-legislation"
            multiple
            label="Legislation Options"
            renderOption={renderOption}
        />
    )

    function setLegislation(_, value) {
        setEnglish(value.includes(LAWS.english))
        setWelsh(value.includes(LAWS.welsh))
        setScottish(value.includes(LAWS.scottish))
        setNorthernIreland(value.includes(LAWS.northernIreland))
    }

    function renderOption(props, option) {
        return (
            <li {...props} data-cy={`${toDataCy("mapping-setting-legislation", option)}`}>
                <Typography component="span">{option}</Typography>
            </li>
        )
    }
}
